<div class="text-center">
    <mat-icon>developer_board</mat-icon>
    <h1 mat-dialog-title translate> dialog.slotmodel.copy</h1>
  
    <div class="modal-body" mat-dialog-content>
  
        <help-alert text = "help.page.new_service.field" info = "help.info" description = "help.page.new_service.description"></help-alert>

        <div class="card container">
            <div class="row mt-2">
                <div class="col-md">
                    <div *ngFor="let day of dayList" style="display: flex; align-items: flex-start;">
                        <mat-checkbox [(ngModel)] = "day.active" [disabled]="day.base">
                            <span translate> {{ day.day }} </span>
                        </mat-checkbox>
                    </div>
                </div>
            </div>
        </div>  
      
    </div>
  
  
    <div class="modal-footer" mat-dialog-actions translate>

        <button type="button" class="btn btn-outline-danger" (click)="cancel()" translate>
        dialog.service.generic.cancel
        </button>

        <button type="button" class="btn btn-outline-secondary" (click)="apply()"
        translate>
        dialog.slotmodel.confirm
        </button>


    </div>

</div>